import { IPagination, IPaginationDTO } from './pagination.model';

export enum RedirectsEndpoints {
  REDIRECTS = '/redirects',
}

export enum RedirectType {
  TEMPORARY = 302,
  PERMANENT = 301,
}

type FullUrl = string;

export interface IRedirect {
  id: string;
  created_at: string;
  updated_at: string;
  type: RedirectType;
  source: FullUrl;
  target: FullUrl;
}

// ----------------- DTOs ----------------

export interface IGetRedirectsDTO extends Partial<IPaginationDTO> {
  type?: RedirectType;
  source?: FullUrl;
  target?: FullUrl;
}

export interface IGetRedirectDTO {
  id: string;
}

export interface ICreateRedirectDTO {
  type: RedirectType;
  source: FullUrl;
  target: FullUrl;
}

export interface IUpdateRedirectDTO extends Partial<ICreateRedirectDTO> {
  id: string;
}

export interface IDeleteRedirectDTO {
  id: string;
}

// ------------ Responses --------------

export interface IGetRedirectResponse {
  data: IRedirect;
}

export interface IGetRedirectsResponse {
  data: IRedirect[];
  meta: IPagination;
}
